import ApiService from "../../../../commons/services/ApiService";
import CompanyAPI from "../../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class PackageSubscriptionAPI {

  URI_V1 = "/v1/packages/sales"

  bulkCreate = async (data: any) => {
    return await apiService.post(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`, data);
  };

  getCustomersByPackage = async (packageId: any) => {
    return await apiService.get(`${this.URI_V1}/${packageId}/customers?companyId=${companyAPI.getCompanyManagment().id}`);
  };

  cancel = async (packageSaleId: any) => {
    return await apiService.patch(`${this.URI_V1}/${packageSaleId}/cancel?companyId=${companyAPI.getCompanyManagment().id}`, null);
  };

  findPackagesByCustomer = async (customerId: any) => {
    return await apiService.get(`${this.URI_V1}/customers/${customerId}/sales?companyId=${companyAPI.getCompanyManagment().id}`);
  };

}
